export default __webpack_public_path__ + "static/media/ConnectBG.b1d9243d.png";